import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, Dimmer, Divider, Loader } from 'semantic-ui-react';
import useClientDetails from '../../hooks/useClientDetails';
import { setEditClient } from '../../redux/actions/clients';
import EntityData from '../Common/EntityData';
import ClientData from './ClientData';
import AddClientGroup from '../ClientGroups/AddClientGroup';
import ExistingClientGroup from '../ClientGroups/ExistingClientGroup';
import { removeClientFromGroup } from '../../redux/actions/clientGroups';

const ClientDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { clients, tasks, users, credentials, uiModules, isLoading } =
    useClientDetails(id);
  const [addClientGroup, setAddClientGroup] = useState(false);
  const [existingClientGroup, setExistingClientGroup] = useState(false);

  const dispatch = useDispatch();
  const client = clients[id];

  return (
    <div>
      {isLoading || !client ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <div>
          {addClientGroup && (
            <AddClientGroup setAddClientGroup={setAddClientGroup} id={id} />
          )}
          {existingClientGroup && (
            <ExistingClientGroup
              setExistingClientGroup={setExistingClientGroup}
              id={id}
            />
          )}

          <EntityData entity={client} />
          <Button onClick={() => dispatch(setEditClient(client))}>
            Edit Client
          </Button>
          {!client.GroupId && (
            <>
              <Button
                onClick={() => {
                  setAddClientGroup((val) => !val);
                }}
              >
                Create New Group with Existing Client
              </Button>
              <Button
                onClick={() => {
                  setExistingClientGroup((val) => !val);
                }}
              >
                Add Client to Group
              </Button>
            </>
          )}
          {client.GroupId && (
            <Button
              onClick={() => {
                dispatch(removeClientFromGroup(id, client.GroupId));
              }}
            >
              Remove Client from Group
            </Button>
          )}
          <Divider horizontal />
          <ClientData
            data={{ tasks, uiModules, users, credentials, client }}
            id={id}
          />
          {/* <Tab panes={panes} defaultActiveIndex={0} renderActiveOnly={true} /> */}
        </div>
      )}
    </div>
  );
};

export default ClientDetails;
